import React from 'react';
import { useTranslation } from 'react-i18next';
import { Notification, NotificationStatus } from '@cp-shared-19/frontend-ui';
import { PersonalDetailsEditStatus } from 'cpes-common';

export const NotificationForLastEditStatus: React.FC<{ lastEditStatus: PersonalDetailsEditStatus }> = ({
    lastEditStatus,
}) => {
    const { t } = useTranslation('my-profile-contact-details');

    switch (lastEditStatus) {
        case 'SUCCESS': {
            return (
                <Notification
                    status={NotificationStatus.success}
                    headline={t('consultView.editStatus.success.title')}
                    testId={'lastEditStatus'}
                >
                    {t('consultView.editStatus.success.text')}
                </Notification>
            );
        }
        case 'SUCCESS_PENDING': {
            return (
                <Notification
                    status={NotificationStatus.warning}
                    headline={t('consultView.editStatus.successPending.title')}
                    testId={'lastEditStatus'}
                >
                    {t('consultView.editStatus.successPending.text')}
                </Notification>
            );
        }
        case 'CHANGE_ERROR': {
            return (
                <Notification
                    status={NotificationStatus.error}
                    headline={t('consultView.editStatus.businessError.title')}
                    testId={'lastEditStatus'}
                >
                    {t('consultView.editStatus.businessError.text')}
                </Notification>
            );
        }
        case 'PARTIAL_CHANGE_ERROR': {
            return (
                <Notification
                    status={NotificationStatus.error}
                    headline={t('consultView.editStatus.partialChangeError.title')}
                    testId={'lastEditStatus'}
                >
                    {t('consultView.editStatus.partialChangeError.text')}
                </Notification>
            );
        }
        case 'UNEXPECTED_ERROR': {
            return (
                <Notification
                    status={NotificationStatus.error}
                    headline={t('consultView.editStatus.unexpectedError.title')}
                    testId={'lastEditStatus'}
                >
                    {t('consultView.editStatus.unexpectedError.text')}
                </Notification>
            );
        }
        default: {
            return null;
        }
    }
};
